import React from "react"
import { Container, Row, Col, Form } from "react-bootstrap"
import useForm from "../useForm"

const MultiContact = props => {
  const {
    values,
    handleChange: formHandleChange,
    addValidationError,
    removeValidationError,
  } = props

  const handleBlur = e => {
    handleChange(e)
  }

  const handleChange = e => {
    formHandleChange(e)
    if (isValid(e)) {
      removeValidationError(e.target.name)
    }
  }

  const isValid = e => {
    const { name, value } = e.target
    if (name === "email" && !value) {
      addValidationError("Email invalid", name)
      return false
    }
    if (name === "phone" && value.length < 8) {
      addValidationError("Invalid phone number", name)
      return false
    }
    if (name === "postcode" && !value) {
      addValidationError("Postcode invalid", name)
      return false
    }

    return true
  }

  return (
    <div>
      <Container>
        <Row className="justify-content-center">
          <Col>
            {/* <Form autoComplete="on"> */}
              <Form.Row>
                <Form.Group as={Col} controlId="postcode" xs={12} sm={4}>
                  <div className="row-question">
                    <Form.Label>Postcode</Form.Label>
                    <Form.Control
                      className="text-field"
                      as="input"
                      type="text"
                      placeholder="Postcode"
                      name="postcode"
                      value={values.postcode}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      required
                      autoComplete="postal-code"
                    ></Form.Control>
                  </div>
                </Form.Group>
                <Form.Group as={Col} controlId="phone" xs={12} sm={4}>
                  <div className="row-question">
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                      className="text-field"
                      type="tel"
                      as="input"
                      placeholder="Phone"
                      name="phone"
                      value={values.phone}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      required
                      autoComplete="tel"
                    ></Form.Control>
                  </div>
                </Form.Group>
                <Form.Group as={Col} controlId="email" xs={12} sm={4}>
                  <div className="row-question">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      className="text-field"
                      type="email"
                      maxLength="321"
                      as="input"
                      placeholder="Email"
                      name="email"
                      value={values.email}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      required
                      autoComplete="email"
                    ></Form.Control>
                  </div>
                </Form.Group>
              </Form.Row>
            {/* </Form> */}
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default MultiContact
